import { useHistory } from 'react-router-dom';

import queryString from 'query-string';

const Root = () => {
  const history = useHistory();
  const queryParams = queryString.parse(history.location.search) as { token?: string; email?: string };
  const { email } = queryParams;

  if (history.location.pathname !== '/corporate') return null;

  if (email) {
    history.replace(`/corporate/registration?email=${email}`);
    return null;
  }

  history.replace('/corporate/login');
  return null;
};

export default Root;
